// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../../../types';

export const StarsWrapper = styled<any, Theme>('section')`
  flex-grow: 1;
`;

const starsDefault = css`
  height: 2rem;
  margin: 0;
  max-width: 9rem;
`;

const starsNonDefault = css`
  height: 2.5rem;
  margin: 0 auto;
  max-width: 12rem;
`;

type Props = {
  view: string,
};

export default styled<any, Theme, Props>('div')`
  display: flex;
  flex-direction: row;

  ${props => (props.view === 'default' ? starsDefault : starsNonDefault)};

  svg {
    flex-grow: 1;
    margin-right: .25rem;
  }
`;
